<template>
    <v-main>
        <v-card class="ma-2">
            <v-toolbar color="primary" flat dark>
                <v-card-title>
                    Envío de correos de confirmación
                </v-card-title>
            </v-toolbar>
            <v-card-actions>
                <v-btn
                    @click="prepareEmails" 
                    text color="primary"
                >Preparar correos</v-btn>
                <v-spacer></v-spacer>
                <v-btn
                    :disabled="emails.length == 0"
                    @click="sendEmails" 
                    text color="primary"
                >Enviar correos</v-btn>
            </v-card-actions>
            <v-divider></v-divider>
            <v-card-text>
                <span v-if="emails.length == 0">Todavía no se ha generado ningún mensaje</span>
                <div v-else>
                    <v-card
                        :key="emailIndex" v-for="(email,emailIndex) in emails"
                        class="ma-1"
                    >
                        <v-toolbar flat height="40">
                            <b>{{ email.email }}</b>
                        </v-toolbar>
                        <v-divider></v-divider>
                        <v-card-text v-html="email.message">
                        </v-card-text>
                    </v-card>
                </div>
            </v-card-text>
        </v-card>
    </v-main>
</template>

<script>

//import {
  //newId,
  //fs,
  //auth,
  //tokens,
  //students,
  //activities,
  //messages,
  //properties,
  //groups
//} from "../firebaseConfig.js";

import {
    newId, activities, messages
} from "../firebaseConfig.js";

import moment from "moment";

export default {
    /* eslint-disable no-console */
    data() {
        return {
            emails: [],
            emailsData: {},
        }
    },
    methods: {
        showDate(date) {
            return moment(date).format('LLL')
        },
        prepareEmails() {
            messages.get().then((messagesQuery)=>{
                messagesQuery.forEach((messageDoc)=>{
                    messageDoc.ref.delete();
                })
            })
            this.emails = [];
            activities.get().then((groupsQuery)=>{
                groupsQuery.forEach((groupQuery)=>{
                    let activity = groupQuery.data();
                    Object.values(activity.groups).forEach((group)=>{
                        let subcribed = Object.keys(group.students).length;
                        let min = parseInt(activity.min);
                        let max = parseInt(activity.max);
                        Object.values(group.students).forEach((student)=>{
                            if(!this.emailsData[student.email]) this.emailsData[student.email] = {
                                email: student.email,
                                children: {},
                                date: null,
                            }
                            if(!this.emailsData[student.email].children[student.name]) this.emailsData[student.email].children[student.name] = {
                                name: student.name.split(', ')[1].split(' del')[0].split(' de la')[0].split(' de')[0].trim(),
                                activities: {}
                            }
                            let message = '';
                            if(student.index >= max-1) message = `No es posible la inscripción debido a que el grupo ya esta completo.`
                            if(student.index < max && subcribed >= min) message = `Inscrito en el <b>${group.name}</b> con horario <b>${group.schedule}</b>.`
                            if(subcribed < min) message = `El grupo no se ha formado debido a la falta de demanda.`
                            if(!this.emailsData[student.email].date || new Date(1000*student.date.seconds) > this.emailsData[student.email].date) this.emailsData[student.email].date = new Date(1000*student.date.seconds)
                            this.emailsData[student.email].children[student.name].activities[activity.name] = {name: activity.name, message}
                        })
                    })
                })
                Object.values(this.emailsData).forEach((emailData)=>{
                    let body = `
                        <p>Estimada Familia:</p>
                        <p>Se han encontrado errores en los últimos correos enviados.</p>
                        <p>Por favor, ignore cualquier correo anterior, el resultado correcto es el que se muestra en este email. Perdón por las molestias que esto les haya podido ocasionar.</p>
                        <p>Aquí tiene un resumen de las gestiones realizadas.</p>
                        <p>Fecha y hora de la gestión: <b class="gray">${this.showDate(emailData.date)}</b></p>
                        <ul>`;
                    Object.values(emailData.children).forEach((child)=>{
                        body += `<li><b>${child.name}</b><ul>`
                        Object.values(child.activities).forEach((activity)=>{
                            body += `<li>${activity.name}: ${activity.message}</li>`
                        })
                        body += `</ul></li>`
                    })
                    body += `</ul>
                            <br>
                            <p>Por favor, revise que todo es correcto. Si encuentra alguna discrepancia comuníquenoslo respondiendo a este correo y resolveremos la incidencia manteniendo la fecha en que se realizó la gestión inicial.</p>
                            <p>También puede ponerse en contacto con nosotros si tiene cualquier otra consulta, estaremos encantados de atenderle.</p>
                            <style>
                            .gray {
                                color: grey;
                            }
                            .group {
                                border: 1px solid lightgrey;
                                padding: 0px 5px 0px 5px;
                                margin: 0px 5px 0px 5px;
                                border-radius: 5px;
                            }
                            .son-name {
                                color: grey;
                                margin-top: 20px;
                                border-bottom: 1px solid lightgrey;
                            }
                        </style>`
                    this.emails.push({
                        date: emailData.date,
                        email: emailData.email,
                        id: newId(),
                        message: body
                    })
                })
            })
        },
        sendEmails() {
            this.emails.forEach((email)=>{
                messages.doc(email.id).set(email);
            })
        }
    }
}
</script>